/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_PlayersInputs */

const th_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้เล่นของคุณ`)
};

const en_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your players`)
};

const ja_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの選手`)
};

const zh_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的球员`)
};

const es_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus jugadores`)
};

const pt_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus jogadores`)
};

const id_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain Anda`)
};

const fr_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos joueurs`)
};

const tl_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga manlalaro mo`)
};

const vi_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cầu thủ của bạn`)
};

const ko_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 선수`)
};

const de_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Spieler`)
};

const ru_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши игроки`)
};

const tr_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyuncularınız`)
};

const it_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi giocatori`)
};

const pl_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoi zawodnicy`)
};

const uk_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваші гравці`)
};

const hi_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके खिलाड़ी`)
};

const ar_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لاعبوك`)
};

const ms_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain anda`)
};

const bn_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার খেলোয়াড়`)
};

const zh_tw2_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的球員`)
};

const zh_hk2_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的球員`)
};

const ur_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کے کھلاڑی`)
};

const fa_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازیکنان شما`)
};

const sw_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachezaji wako`)
};

const nl_your_players = /** @type {(inputs: Your_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw spelers`)
};

/**
* | output |
* | --- |
* | "Your players" |
*
* @param {Your_PlayersInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_players = /** @type {((inputs?: Your_PlayersInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_PlayersInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_your_players(inputs)
	if (locale === "ja") return ja_your_players(inputs)
	if (locale === "zh") return zh_your_players(inputs)
	if (locale === "es") return es_your_players(inputs)
	if (locale === "pt") return pt_your_players(inputs)
	if (locale === "id") return id_your_players(inputs)
	if (locale === "fr") return fr_your_players(inputs)
	if (locale === "tl") return tl_your_players(inputs)
	if (locale === "vi") return vi_your_players(inputs)
	if (locale === "ko") return ko_your_players(inputs)
	if (locale === "de") return de_your_players(inputs)
	if (locale === "ru") return ru_your_players(inputs)
	if (locale === "tr") return tr_your_players(inputs)
	if (locale === "it") return it_your_players(inputs)
	if (locale === "pl") return pl_your_players(inputs)
	if (locale === "uk") return uk_your_players(inputs)
	if (locale === "hi") return hi_your_players(inputs)
	if (locale === "ar") return ar_your_players(inputs)
	if (locale === "ms") return ms_your_players(inputs)
	if (locale === "bn") return bn_your_players(inputs)
	if (locale === "zh-TW") return zh_tw2_your_players(inputs)
	if (locale === "zh-HK") return zh_hk2_your_players(inputs)
	if (locale === "ur") return ur_your_players(inputs)
	if (locale === "fa") return fa_your_players(inputs)
	if (locale === "sw") return sw_your_players(inputs)
	if (locale === "nl") return nl_your_players(inputs)
	return en_your_players(inputs)
});